import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import ReactPasswordStrength from 'react-password-strength';
import querystring from 'querystring';

import { updateRegistration } from '../../Actions/Password/register';

class Password extends React.Component {
  state = {
    password: '',
    conf: '',
    error: false,
  };

  processPassword = (e) => {
    e.preventDefault();
    const q = querystring.parse(window.location.search.substr(1));
    if (this.state.password.isValid && this.state.conf.isValid) {
      if (this.state.password.password === this.state.conf.password) {
        const data = {
          hash: q.h,
          client_id: q.i,
          password: this.state.password.password,
          password_confirmation: this.state.conf.password,
        };
        this.props.dispatch(updateRegistration(data));
      } else {
        this.setState({ error: 'Sorry the passwords enter do not match' });
      }
    } else {
      this.setState({ error: 'Sorry passwords not valid' });
    }
  };

  render() {
    return (
      <div className="wrap reset-password">
        <fieldset>
          {this.state.error ? (
            <div className="form-register_question">
              <p className="alert-error justifycentre">{this.state.error}</p>
            </div>
          ) : null}
          {this.props.regerror.status && this.props.regerror.status === 'error' ? (
            <div className="form-register_question">
              <p className="alert-error justifycentre">{this.props.regerror.msg}</p>
            </div>
          ) : null}
          {this.props.regerror.status && this.props.regerror.status === 'ok' ? (
            <div>
              <h1 className="h2 justifycentre">Welcome to MyLiveWell</h1>
              <p className="justifycentre">Thanks for adding a password, you can now login via the below link.</p>
              <p className="justifycentre">
                <a href="/login" className="button">
                  Login Now
                </a>
              </p>
            </div>
          ) : (
            <form onSubmit={this.processPassword} className="form-register">
              <h1 className="h2 justifycentre">Create a Password</h1>
              <p className="justifycentre">
                We’re thrilled that you’ve decided to join us. We have a whole host of personalised tools, tips, tricks and
                <br />
                advice for you within MyLiveWell, to complete creating your account please choose a password.
              </p>

              <div className="form-register_question">
                <label>
                  New Password:
                  <ReactPasswordStrength
                    minLength={10}
                    minScore={1}
                    scoreWords={['weak', 'okay', 'good', 'strong', 'stronger']}
                    inputProps={{ autoComplete: 'off', className: 'form-control' }}
                    changeCallback={password => this.setState({ password })}
                  />
                </label>
              </div>
              <div className="form-register_question">
                <label>
                  Password Confirm:
                  <ReactPasswordStrength
                    minLength={10}
                    minScore={1}
                    scoreWords={['weak', 'okay', 'good', 'strong', 'stronger']}
                    inputProps={{ autoComplete: 'off', className: 'form-control' }}
                    changeCallback={conf => this.setState({ conf })}
                  />
                </label>
              </div>
              <div className="form-register_question justifycentre">
                <input type="submit" value="Create an account" className="button" />
              </div>
            </form>
          )}
        </fieldset>
      </div>
    );
  }
}

Password.propTypes = {
  dispatch: PropTypes.func.isRequired,
  regerror: PropTypes.object,
};

Password.defaultProps = {
  regerror: {},
};

export default connect(
  state => ({
    regerror: state.passwordreg,
    login: state.login,
  }),
  dispatch => ({ dispatch }),
)(Password);



// WEBPACK FOOTER //
// ./src/Components/Password/index.jsx